module.exports = __webpack_public_path__ + "media/prepaid-cards/prepaid-5000-911e69e6.png";